module.exports = __webpack_public_path__ + "media/images/Tiled-Church-Wall-2-905ae9cfe8ece1839b887a4289b1a02b.jpg";